var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link",style:({'opacity': _vm.opacity}),on:{"click":_vm.openLink}},[_c('img',{attrs:{"src":require("../../assets/link.svg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }